// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet polis-public API
 * OpenAPI spec version: 1
 */

export type SUREbusinessCommonDomainSoortVerzekeringEnum =
  (typeof SUREbusinessCommonDomainSoortVerzekeringEnum)[keyof typeof SUREbusinessCommonDomainSoortVerzekeringEnum];

export const SUREbusinessCommonDomainSoortVerzekeringEnum = {
  AB: 'AB',
  AP: 'AP',
  BB: 'BB',
  BR: 'BR',
  CO: 'CO',
  MR: 'MR',
  MV: 'MV',
  OG: 'OG',
  OI: 'OI',
  PO: 'PO',
  PP: 'PP',
  RB: 'RB',
  RE: 'RE',
  TR: 'TR',
  VA: 'VA',
  VB: 'VB',
  VR: 'VR',
  ZK: 'ZK',
  WP: 'WP',
} as const;
